module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-half mp-user-column"
  }, [_c('div', {
    class: 'team-indicator team-' + _vm.score.Team
  }), _vm._v(" "), _c('a', {
    staticClass: "force32",
    attrs: {
      "href": 'https://ripple.moe/u/' + _vm.uid,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "force32",
    attrs: {
      "src": 'https://a.ripple.moe/' + _vm.uid
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.users[_vm.uid] ? _vm.users[_vm.uid].username : "...") + "\n      —\n      " + _vm._s(_vm.score.Score.toLocaleString()) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.scoreMods(_vm.score.Mods)))])]), _vm._v(" "), _c('span', {
    staticClass: "icon"
  }, [(_vm.score.Failed) ? _c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "title": "Failed (including at the end)"
    }
  }) : (!_vm.score.Pass) ? _c('i', {
    staticClass: "fa fa-wheelchair-alt",
    attrs: {
      "title": "Not passed (hp restored before the end), also displayed on older games"
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9db5796","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserScore.vue
// module id = 147
// module chunks = 1